import { Checkbox, Form, Modal, Select, Spin } from "antd";
import Input from "antd/es/input/Input";
import { useFormik } from "formik";
import { memo, useEffect, useState } from "react";
import { folderDeleteValidationScheme } from "../../../schemas/formValidationScheme";
import TextArea from "antd/es/input/TextArea";
import { fetchDocumentMetaData, fetchEditDocumentMetaData, fetchTargetLanguageList, fetchUploadMetaData, resetSelectedDocument, updateDocumentMetaData } from "../../../redux/EngageTranslation/EngageTranslationAction";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { useAppDispatch } from "../../../redux/useAppDispatch";

type EditDocumentProps = {
  close: () => void;
  openState: boolean;
  open: () => void;
};
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
  },
};
function EditDocumentInfoModal(props: EditDocumentProps) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [isChanged, setIsChanged] = useState(false);
  const uploadFormState = useSelector((state: RootState) => state.engageTranslationState.engageTranslateMainState.uploadFormMetaDataState);
  const metaData = useSelector((state: RootState) => state.engageTranslationState.newTabState.selectedDocument.metaData);
  const selectDocumentState = useSelector((state: RootState) => state.engageTranslationState.newTabState.selectedDocument);
  const selectedSingleDocument = useSelector((state: RootState) => state.engageTranslationState.newTabState.selectedTranslatedDocumentID);
  const clearUpdateForm = () => {
    form.resetFields();
  };

  console.log(uploadFormState);
  console.log(metaData);
  useEffect(() => {
    if (props.openState) {
      console.log(selectDocumentState.selectedDocumentID, selectedSingleDocument);
      dispatch(fetchEditDocumentMetaData({ selectedDocumentID: selectedSingleDocument, selectedID: selectDocumentState.selectedDocumentID }));
    } else {
      dispatch(resetSelectedDocument({ view: "new" }));
    }
    return () => {
      setIsChanged(false);
      clearUpdateForm();
    };
  }, [props.openState]);

  useEffect(() => {
    if (props.openState) {
      // console.log(selectDocumentState.metaData.client.name, selectDocumentState.metaData.sourceLanguage.name);
      form.setFieldsValue(selectDocumentState.metaData);
    }
  }, [selectDocumentState.metaData, props.openState]);

  const EditDocumentInfoModalContent = () => {
    const handleSubmission = async (values: any) => {
      // dispatch(documentUpload(values));
      dispatch(
        updateDocumentMetaData({
          ...values,
          id: selectedSingleDocument,
          translatedDocId: selectDocumentState.selectedDocumentID,
        })
      );
      // dispatch(updateDocumentMetaData(values))
      props.close();
    };

    const preventMinus = (e: any) => {
      if (e.code === "Minus") {
        e.preventDefault();
      }
    };

    // console.log(errors);
    return (
      <Spin spinning={selectDocumentState.loading}>
        <div className=" d-flex flex-column justify-content-between gap-4 h-100">
          <h4>Edit document information</h4>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-2">
              <Form
                form={form}
                onFinish={(values) => {
                  handleSubmission(values);
                }}
                onValuesChange={() => setIsChanged(true)}
                scrollToFirstError
                {...formItemLayout}
                colon={false}>
                <Form.Item
                  name="name"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please provide Document Name.",
                    },
                  ]}
                  label="Document">
                  <Input />
                </Form.Item>
                <Form.Item
                  name={"description"}
                  label="Description">
                  <TextArea
                    rows={4}
                    placeholder="Description"
                    showCount
                    maxLength={100}
                  />
                </Form.Item>
                <Form.Item
                  name="clientId"
                  required
                  rules={[{ required: true, message: "Please provide Client Name." }]}
                  label="Client Name">
                  <Select
                    defaultValue={metaData.sourceLanguageName}
                    options={uploadFormState.clientList}
                  />
                </Form.Item>
                <Form.Item
                  name={"engageProductionId"}
                  required
                  rules={[
                    {
                      validator: (rule, value, callback) => {
                        // Custom validation logic
                        //convert 00 to 0 000 to 0 0000 to 0
                        //validate if the value is smaller than 0

                        if (Number(value) <= 0) {
                          callback("Please provide valid ID");
                        } else {
                          callback();
                        }
                      },
                    },
                    // { pattern: new RegExp(/^[0-9]+$/), message: "Please provide valid ID" },
                    // { required: true, message: "Please provide valid ID" },
                  ]}
                  label="Engage ID">
                  <Input
                    type="number"
                    min={0}
                    onKeyDown={preventMinus}
                  />
                </Form.Item>
                <Form.Item
                  name={"sourceLanguageId"}
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please provide Source Language.",
                    },
                  ]}
                  label="Source Language">
                  <Select
                    onChange={(value) => {
                      dispatch(fetchTargetLanguageList(value));
                      form.setFieldsValue({ targetLanguageId: null });
                    }}
                    options={uploadFormState.sourceLanguageList}
                  />
                </Form.Item>
                <Form.Item
                  name={"targetLanguageId"}
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please provide Output Language.",
                    },
                  ]}
                  label="Output Language">
                  <Select options={uploadFormState.targetLanguageList} />
                </Form.Item>
                <Form.Item
                  required
                  name={"uploadedBy"}
                  rules={[
                    { type: "email", message: "Please provide valid email" },
                    {
                      required: true,
                      message: "Please provide Workflow Coordinator.",
                    },
                  ]}
                  label="Workflow Coordinator">
                  <Input />
                </Form.Item>

                <Form.Item
                  required
                  valuePropName="checked"
                  name={"isScanned"}>
                  <Checkbox>Scanned</Checkbox>
                </Form.Item>
              </Form>

              <div className="d-flex gap-4 justify-content-end">
                <button
                  disabled={!isChanged}
                  onClick={() => form.submit()}
                  className="button">
                  Confirm
                </button>
                <button
                  type="button"
                  onClick={() => {
                    props.close();
                  }}
                  // form="createNewFolderForm"
                  className="button warning">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </Spin>
    );
  };
  const FileUploadModalWidth = "30%";
  return (
    <Modal
      //   width={FileUploadModalWidth}
      centered
      zIndex={1500}
      footer={[]}
      onCancel={() => props.close()}
      open={props.openState}>
      <EditDocumentInfoModalContent />
    </Modal>
  );
}
function arePropsEqual(oldProps: EditDocumentProps, newProps: EditDocumentProps) {
  return oldProps.openState === newProps.openState;
}

export default memo(EditDocumentInfoModal, arePropsEqual);
